class BESSAppToolNotesLink extends BESSAppComponent {

    constructor() {
        super('.app-tool-notes-link');
    }

    setupComponent(componentNode) {
        let engineVersion = BESSApp.instance.sections.project.engineVersion;
        let extra = componentNode.attr('data-doc-id') !== undefined ? componentNode.attr('data-doc-id') : "";
        if (engineVersion !== undefined) {
            componentNode.attr('href', '/app/tool-notes/BESS' + engineVersion + (extra ? ('/' + extra) : ''));
        } else {
            componentNode.attr('href', '/app/tool-notes/' + extra);
        }
        componentNode.attr('target', 'tool-notes');
    }
}